import React, { ReactElement } from "react";
import FeedbackList from "../../components/Feedback";
import Layout from "../../components/layout";

const FeedbackPage = (): ReactElement => {
  return (
    <Layout>
      <FeedbackList />
    </Layout>
  );
};

export default FeedbackPage;
